import { NormalizedTicketTypeVariety } from '../../types/ticketPriceInformation';
import { consumer } from '@tock/coretypes';

/**
 * The natural name of an offering is the name used in regular language.
 * This can be placed into text on the dashboard or consumer sites.
 */

export type OfferingNaturalName = 'experience' | 'experiences' | 'event' | 'events' | 'special table' | 'special tables';
const varietyToOfferingNaturalNameMap: {
  [K in NormalizedTicketTypeVariety | consumer.Offering.Type]: OfferingNaturalName;
} = {
  DEPOSIT: 'experience',
  FULL: 'experience',
  PRIX_FIXE: 'experience',
  RESERVATION: 'experience',
  DEPRECATED_EVENT: 'event',
  GA_EVENT: 'event',
  SEATED_EVENT: 'event',
  DEPRECATED_SPECIAL_TABLE: 'special table',
  ORDER_DELIVERY: 'experience',
  ORDER_PICKUP: 'experience',
  TABLESIDE: 'experience',
  PAYMENT_CARD_HOLD: 'experience',
};
const varietyToOfferingPluralizedNaturalNameMap: {
  [K in NormalizedTicketTypeVariety | consumer.Offering.Type]: OfferingNaturalName;
} = {
  DEPOSIT: 'experiences',
  FULL: 'experiences',
  PRIX_FIXE: 'experiences',
  RESERVATION: 'experiences',
  DEPRECATED_EVENT: 'events',
  GA_EVENT: 'events',
  SEATED_EVENT: 'events',
  DEPRECATED_SPECIAL_TABLE: 'special tables',
  ORDER_DELIVERY: 'experiences',
  ORDER_PICKUP: 'experiences',
  TABLESIDE: 'experiences',
  PAYMENT_CARD_HOLD: 'experiences',
};

/**
 * Returns the natural name of a variety (optionally pluralized)
 * e.g. RESERVATION -> experience, SPECIAL_TABLE -> special table, DEPOSIT -> experience
 */
export function offeringNaturalName(
  variety: NormalizedTicketTypeVariety | consumer.Offering.Type,
  pluralize: boolean = false
): OfferingNaturalName {
  return pluralize ? varietyToOfferingPluralizedNaturalNameMap[variety] : varietyToOfferingNaturalNameMap[variety];
}
